import React from 'react';
import { Mail, Instagram, Facebook, Youtube, Info, Phone, Send } from 'react-feather';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-900 text-white py-1 px-6 mt-auto sticky bottom-0 left-0 right-0 z-50">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row items-center justify-between py-1 space-y-1 lg:space-y-0">
          {/* Copyright Section */}
          <div className="text-center lg:text-left order-2 lg:order-1">
            <p className="text-xs font-medium">
              © {currentYear} TenaRx Pharmacy. All rights reserved.
            </p>
            <p className="text-xs text-gray-400 mt-0">
              Developed with ❤️ for better healthcare
            </p>
          </div>
          
          {/* Links Section */}
          <div className="flex items-center space-x-6 order-1 lg:order-2">
            <Link 
              to="/about" 
              className="text-xs text-gray-400 hover:text-white transition-colors duration-200 flex items-center"
              title="About TenaRx"
            >
              <Info size={14} className="mr-1" />
              About
            </Link>
          </div>
          
          {/* Social Media Links */}
          <div className="flex items-center space-x-4 order-3">
            <span className="text-xs text-gray-400 mr-2 hidden sm:inline">Connect:</span>
            <div className="flex space-x-3">
              <span className="text-xs text-gray-400">+251980472038</span>
              <a 
                href="mailto:tenarx.net@gmail.com?subject=Inquiry%20from%20TenaRx&body=Hello%20TenaRx%20Team," 
                className="text-gray-400 hover:text-red-500 transition-colors duration-200 transform hover:scale-110"
                title="Email"
              >
                <Mail size={16} />
              </a>
              <a 
                href="https://t.me/tenarxnet" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-400 transition-colors duration-200 transform hover:scale-110"
                title="Telegram"
              >
                <Send size={16} />
              </a>
              <a 
                href="https://instagram.com/tenarx_net" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-pink-500 transition-colors duration-200 transform hover:scale-110"
                title="Instagram"
              >
                <Instagram size={16} />
              </a>
              <a 
                href="https://facebook.com/tenarx" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-500 transition-colors duration-200 transform hover:scale-110"
                title="Facebook"
              >
                <Facebook size={16} />
              </a>
              <a 
                href="https://tiktok.com/@tenarx" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-gray-100 transition-colors duration-200 transform hover:scale-110"
                title="TikTok"
              >
                <Youtube size={16} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
